<template>
  <div>
    <div class="d-flex flex-wrap align-items-center mb-4">
      <ConsoleLink :to="{ name: 'store.list' }" class="mr-2 mb-2">
        <a-icon type="arrow-left" />
      </ConsoleLink>
      <h4 class="mb-0 mr-5 mb-2">
        {{ $t('sideBar.add_store') }}
      </h4>
      <a-breadcrumb separator=">" class="mb-2">
        <a-breadcrumb-item>
          <ConsoleLink :to="{ name: 'store.list' }">
            {{ $t('store_list_page.store_list') }}
          </ConsoleLink>
        </a-breadcrumb-item>
        <a-breadcrumb-item>
          {{ $t('sideBar.add_store') }}
        </a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <a-spin :spinning="loadingIntegration" :tip="$t('add_store.loading_integration')">
      <div :class="$style.wrapContent" class="mt-4">
        <a-card :title="$t('add_store.marketplace_integration')">
          <card v-for="(data, i) in dataMarketPlace" :key="i" :data-card="data" :open-modal="data?.redirectIntegrate ? openModal : data?.channelCode === 'blibli_id' ? openModalBlibli : data?.channelCode === 'zalora_id' ? openModalZalora : openModalWithForm" />
        </a-card>
        <modal-sync
          :visible="modalSync"
          :open-modal="openModal"
          :open-modal-success="openModalSuccess"
          :id-data="idData"
        />
        <modal-sync-with-form
          :visible="modalSyncWithForm"
          :open-modal="openModalWithForm"
          :open-modal-success="openModalSuccess"
          :id-data="idData"
        />
        <modal-sync-blibli
          :visible="modalSyncBlibli"
          :open-modal="openModalBlibli"
          :open-modal-success="openModalSuccess"
          :id-data="idData"
        />
        <modal-sync-zalora
          :visible="modalSyncZalora"
          :open-modal="openModalZalora"
          :open-modal-success="openModalSuccess"
          :id-data="idData"
        />
        <modal-add-shop 
          :id-data="parseInt(integration?.marketplace.aggregator_id)"
        />
        <modal-success-sync />
        <modal-add-warehouse />
        <ModalUpdateMappingWarehouseV2
          v-if="isTocoWarehouseMapping"
          :visible="warehouseMappingVisible"
          :data="warehouseMappingChannel"
          @onCancel="closeWarehouseMapping"
        />
        <modal-mapping-warehouse-after-integrate-v2 v-else />

        <a-modal
          :visible="visible"
          :footer="null"
          :mask-closable="false"
          :closable="false"
          :keyboard="false"
          :width="320"
          centered
        >
          <div class="text-center">
            <a-icon type="warning" theme="twoTone" two-tone-color="#ffa500" style="font-size: 72px" />
            <p class="mt-4 mb-0" style="font-weight: bold;">
              {{ $t('add_store.integration_failed_title') }}
            </p>
            <p>{{ $t('add_store.integration_failed_warehouse') }}</p>
            <a-button type="primary" style="font-weight: bold;" @click="toWarehouseForm">
              {{ $t('add_store.input_warehouse_btn') }}
            </a-button>
          </div>
        </a-modal>
      </div>
    </a-spin>
  </div>
</template>

<script>
import ConsoleLink from '@/components/ConsoleLink/ConsoleLink.vue'
import Card from '@/components/Store/AddStore/Card.vue'
import ModalSync from '@/components/Store/AddStore/ModalSync.vue'
import ModalSyncWithForm from '@/components/Store/AddStore/ModalSyncWithForm.vue'
import ModalSyncBlibli from '@/components/Store/AddStore/ModalSyncBlibli'
import ModalSyncZalora from '@/components/Store/AddStore/ModalSyncZalora'
import ModalSuccessSync from '@/components/Store/AddStore/ModalSuccessSync.vue'
import ModalAddWarehouse from '@/components/Store/AddStore/ModalAddWarehouse.vue'
import ModalAddShop from '@/components/Store/AddStore/ModalAddShop.vue'
import ModalMappingWarehouseAfterIntegrateV2 from '@/components/Store/AddStore/ModalMappingWarehouseAfterIntegrateV2.vue'
import ModalUpdateMappingWarehouseV2 from '@/views/store/ModalUpdateMappingWarehouseV2.vue'

import data from '@/services/store/data'

import { bindingTokopedia } from '@/api/channels/tiktok'
import { Modal } from 'ant-design-vue'

export default {
  name: 'AddStore',
  components: {
    ConsoleLink,
    Card,
    ModalSync,
    ModalSuccessSync,
    ModalAddWarehouse,
    ModalAddShop,
    ModalSyncWithForm,
    ModalSyncBlibli,
    ModalSyncZalora,
    ModalMappingWarehouseAfterIntegrateV2,
    ModalUpdateMappingWarehouseV2,
  },
  data() {
    return {
      visible: false,
      modalSync: false,
      modalSyncWithForm: false,
      modalSyncBlibli: false,
      modalSyncZalora: false,
      modalSuccessSync: false,
      modalListMW: false,
      idData: null,
    }
  },
  computed: {
    integration() {
      return this.$store.state.integration
    },
    dataMarketPlace() {
      return data.filter((val) => val.type === 'store')
    },
    dataFulfilment() {
      return data.filter((val) => val.type === 'warehouse')
    },
    loadingIntegration() {
      return this.$store.state.integration.loadingSync
    },
    warehouseMappingVisible() {
      return this.$store.state.integration.modalWarehouseMappingV2
    },
    isTocoWarehouseMapping() {
      return this.$route.query.code === 'toco_id'
    },
    warehouseMappingChannel() {
      return {
        id: this.$route.query.channel_id,
        title: this.$route.query.name || '',
        sales_channel: {
          code: this.$route.query.code,
          name: this.$route.query.name || 'Toco Indonesia',
        },
      }
    },
  },
  mounted() {
    this.fetchWarehouseList()
  },
  methods: {
    closeWarehouseMapping() {
      this.$store.commit('integration/SET_MODAL_WAREHOUSE_MAPPING_V2', false)
    },
    async fetchWarehouseList() {
      return await this.$store
        .dispatch('warehouse/GETWAREHOUSELIST', {
          ...this.$route.query,
          page: 1,
          size: 150,
        })
        .then(response => {
          if(!response.length) {
            this.visible = true
          } else {
            this.syncStore()
          }
        })
        .catch(err => {
          this.visible = true
          console.error(err)
        })
    },
    syncStore() {
      const local = JSON.parse(localStorage.getItem('pathCallback'))
      /* if have code after sync tiktok */
      if (local) {
        const localQuery = {
          ...local,
          query: {
            ...local.query,
            ...this.$route.query,
          },
        }
        localStorage.setItem('pathCallback', JSON.stringify(localQuery))
        if (local?.query?.name?.toLowerCase() === 'shopee') {
          this.$store.dispatch('integration/SYNCSHOPEECONFIRM', {
            sales_channel: local?.query?.sales_channel,
            client_id: local?.query?.client_id,
            business: local?.query?.business_id,
            shop_id: local.query?.shop_id,
            code: local.query?.code,
            main_account_id: local.query?.main_account_id,
          }).then(({ data }) => {
            let modalAddWarehouse = true
            if(data?.code != null && !['200', '201'].includes(data?.code)) {
              modalAddWarehouse = false
              this.$notification.error({
                message: this.$t('add_store.shopee_integration_failed'),
                description: data?.message,
              })
            }
            
            if (typeof localStorage.getItem('pathCallback') === 'string') {
              localStorage.removeItem('pathCallback')
            }
            let channelId = data?.data?.channel_id
            if (!channelId && data?.data?.shop_list?.length > 0) {
              channelId = data?.data?.shop_list[0]?.channel_id
            }
            this.$router.push({
              path: '/add-store',
              query: { ...this.$route.query, business_id: localQuery?.query?.business_id, channel_id: channelId, name: 'shopee', code: 'shopee_id' },
            })
            this.$store.commit('integration/SET_MODAL_WAREHOUSE_MAPPING_V2', modalAddWarehouse)
          })
          .catch(err => {
            if (err.message === 'empty_shop_id') return

            console.error(err)
            let errorMessage = err.response?.data?.message || err.message
            let errorContent = errorMessage

            if (typeof errorMessage === 'string') {
              const jsonStart = errorMessage.indexOf('{')
              const jsonEnd = errorMessage.lastIndexOf('}')
              if (jsonStart !== -1 && jsonEnd !== -1 && jsonEnd > jsonStart) {
                try {
                  const jsonStr = errorMessage.substring(jsonStart, jsonEnd + 1)
                  const parsed = JSON.parse(jsonStr)
                  if (parsed && parsed.message) {
                    errorContent = parsed.message
                  }
                } catch (e) {
                }
              }
            }

            if (typeof errorContent === 'string') {
              if (errorContent.includes('Shop already exist with different business id')) {
                errorContent = this.$t('add_store.errors.shop_already_exist_business_id')
              } else if (errorContent.includes('code is expired or used or invalid') || errorContent.includes('invalid_code')) {
                errorContent = this.$t('add_store.errors.invalid_auth_code')
              }
            }

            Modal.error({
              title: this.$t('add_store.shopee_integration_failed'),
              content: errorContent,
            })

            if (typeof localStorage.getItem('pathCallback') === 'string') {
              localStorage.removeItem('pathCallback')
            }
          })
        } else if (['tiktok', 'tiktok tokopedia'].includes(local?.query?.name?.toLowerCase())) {
          if (
            local?.query.code &&
            local?.query['company-aggregator-id'] &&
            local?.query.name
          ) {
            const finalQueryName = local?.query.name.toLowerCase() === 'tiktok tokopedia' ? 'tiktok' : local?.query.name.toLowerCase()
            this.$store.dispatch('integration/ADDSTOREMARKETPLACE', {
              name: finalQueryName,
              aggregator_id: local.query['company-aggregator-id'],
              code: local.query.code,
              business_id: local?.query?.business_id,
              app_key: localQuery?.query?.app_key,
            }).then(({ data }) => {
              let currentChannelId = data?.data?.channel_id
              const statusChannel = data?.data?.status
              let modalAddWarehouse = true
              if(data?.data?.authorized_shops?.length === 0) {
                modalAddWarehouse = false
                this.$notification.error({
                  message: this.$t('add_store.tiktok_integration_failed'),
                  description: data?.data?.authorized_shops?.[0]?.message,
                })
              }
              if (!currentChannelId) {
                currentChannelId = data?.data?.channels?.find((channel) => channel?.salesChannel?.code?.toLowerCase() === 'tiktok')?.id
              }

              if (typeof localStorage.getItem('pathCallback') === 'string') {
                localStorage.removeItem('pathCallback')
                localStorage.removeItem('channelId')
                localStorage.removeItem('needBinding')
                localStorage.removeItem('tiktok-tokopedia-integrate')
              }

              if (statusChannel?.toUpperCase() === 'PENDING_WAREHOUSE') {
                this.$router.push({
                  path: '/add-store',
                  query: { ...this.$route.query, business_id: localQuery?.query?.business_id, channel_id: currentChannelId, name: 'tiktok', code: 'tiktok' },
                })
                this.$store.commit('integration/SET_MODAL_WAREHOUSE_MAPPING_V2', modalAddWarehouse)
              } else {
                return
              }
            })
          }
        } else if (local?.query?.name?.toLowerCase() === 'lazada') {
          this.$store.dispatch('integration/SYNCLAZADACONFIRM', {
            business_id: local?.query?.business_id,
            code: local?.query?.code,
            client_id: local?.query?.client_id,
            sales_channel: {
              id: local?.query?.sales_channel?.id,
              code: local?.query?.sales_channel?.code,
            },
          }).then(({ data }) => {
            if (typeof localStorage.getItem('pathCallback') === 'string') {
              localStorage.removeItem('pathCallback')
            }
            this.$router.push({
              path: '/add-store',
              query: { ...this.$route.query, business_id: localQuery?.query?.business_id, channel_id: data?.data?.channel_id, name: 'lazada', code: 'lazada_id' },
            })
            this.$store.commit('integration/SET_MODAL_INTEGRATION_ADD_WAREHOUSE', true)
          })
          .catch(err => {
            console.error(err)
            this.$notification.error({
              message: err.response.data.message,
            })
          })
        } else if (local?.query?.name?.toLowerCase() === 'toco') {
          this.$store.dispatch('integration/SYNCTOCOCONFIRM', {
            client_id: local?.query?.client_id,
            business: local?.query?.business_id,
            sid: localQuery?.query?.sid,
          }).then(({ data }) => {
            let modalAddWarehouse = true
            if(data?.code != null && !['200', '201'].includes(data?.code)) {
              modalAddWarehouse = false
              this.$notification.error({
                message: this.$t('add_store.toco_integration_failed'),
                description: data?.message,
              })
            }
            
            if (typeof localStorage.getItem('pathCallback') === 'string') {
              localStorage.removeItem('pathCallback')
            }
            let channelId = data?.data?.channel_id
            if (!channelId && data?.data?.shop_list?.length > 0) {
              channelId = data?.data?.shop_list[0]?.channel_id
            }
            this.$router.push({
              path: '/add-store',
              query: { ...this.$route.query, business_id: localQuery?.query?.business_id, channel_id: channelId, name: 'toco', code: 'toco_id' },
            })
            this.$store.commit('integration/SET_MODAL_WAREHOUSE_MAPPING_V2', modalAddWarehouse)
          })
          .catch(err => {
            if (err.message === 'empty_sid') return

            console.error(err)
            let errorMessage = err.response?.data?.message || err.message
            let errorContent = errorMessage

            if (typeof errorMessage === 'string') {
              const jsonStart = errorMessage.indexOf('{')
              const jsonEnd = errorMessage.lastIndexOf('}')
              if (jsonStart !== -1 && jsonEnd !== -1 && jsonEnd > jsonStart) {
                try {
                  const jsonStr = errorMessage.substring(jsonStart, jsonEnd + 1)
                  const parsed = JSON.parse(jsonStr)
                  if (parsed && parsed.message) {
                    errorContent = parsed.message
                  }
                } catch (e) {
                }
              }
            }

            if (typeof errorContent === 'string') {
              if (errorContent.includes('Shop already exist with different business id')) {
                errorContent = this.$t('add_store.errors.shop_already_exist_business_id')
              } else if (errorContent.includes('code is expired or used or invalid') || errorContent.includes('invalid_code')) {
                errorContent = this.$t('add_store.errors.invalid_auth_code')
              }
            }

            Modal.error({
              title: this.$t('add_store.toco_integration_failed'),
              content: errorContent,
            })

            if (typeof localStorage.getItem('pathCallback') === 'string') {
              localStorage.removeItem('pathCallback')
            }
          })
        }
      }
    },
    openModalWithForm(id) {
      this.modalSyncWithForm = !this.modalSyncWithForm
      this.idData = id
    },
    openModalBlibli(id) {
      this.modalSyncBlibli = !this.modalSyncBlibli
      this.idData = id
    },
    openModalZalora(id) {
      this.modalSyncZalora = !this.modalSyncZalora
      this.idData = id
    },
    openModal(id) {
      this.modalSync =  !this.modalSync
      this.idData = id
    },
    openModalSuccess() {
      this.modalSync = false
      this.modalSuccessSync = !this.modalSuccessSync
    },
    toWarehouseForm() {
      const { workspace_id, business_id, warehouse_id } = this.$route.query
      this.$router.push({
        path: '/warehouse/add-warehouse',
        query: {
          workspace_id,
          business_id,
          warehouse_id,
        },
      })
    },
  },
}
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
